import React, { useState } from "react";
import { Route, Switch, useHistory } from "react-router-dom";
import { Modal, ModalBody, ModalHeader, ModalProps } from "reactstrap";
import {
  FestivalAbout2026,
  FestivalArtists2026,
  FestivalCooperations2026,
  FestivalVenues2026,
} from "./festivalContent/FestivalContent2026";

import FestivalEvent from "./FestivalEvent";

export const FestivalModal = ({
  isOpen,
  toggle,
}: {
  isOpen: boolean;
  toggle: ModalProps["toggle"];
}) => {
  const [name, setName] = useState("About");
  const headerToggle = (e: React.MouseEvent<any, MouseEvent>) => {
    if (toggle) {
      toggle(e as any);
    }
  };

  const history = useHistory();
  return (
    <Modal size="xl" isOpen={isOpen} toggle={toggle} scrollable>
      <ModalHeader className="festival-modal-header" toggle={headerToggle}>
        <h3 style={{ cursor: "pointer" }} onClick={() => history.goBack()}>
          {"<< "}zurück
        </h3>
      </ModalHeader>
      <ModalBody className="festival-modal-body">
        <Switch>
          <Route path="/fm/c/about2026">
            <FestivalAbout2026 setName={setName} />
          </Route>
          <Route path="/fm/c/artists2026">
            <FestivalArtists2026 setName={setName} />
          </Route>
          <Route path="/fm/c/cooperations2026">
            <FestivalCooperations2026 setName={setName} />
          </Route>
          <Route path="/fm/c/venues2026">
            <FestivalVenues2026 setName={setName} />
          </Route>
          <Route path="/fm/:eventId">
            <FestivalEvent setName={setName} />
          </Route>
        </Switch>
      </ModalBody>
    </Modal>
  );
};
